import { apiEndpoint, requestPayload } from '../utils/common';
import { API } from '../constant';
import { post } from '../utils/http';

/* passing txn amount since in case of access token flow amount has to be passed in fetch pcf details */
export function fetchPcfDetails(payMethods, txnAmount) {
  const payload = { payMethods };
  if (txnAmount) {
    payload.txnAmount = txnAmount;
  }
  return post.call(this, apiEndpoint(API.FETCH_PCF_DETAILS), requestPayload(payload));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/pcf.js